import axios from 'axios'
import { createInstance } from './request'

interface IApiConfig {
  [key: string]: string
}

/**
 * 保存实例
 */
const https = {} as any

/**
 * 手动设置请求实例配置
 * @param options { core: '' }
 */
const setApiOptions = (options?: IApiConfig) => {
  if (!options) return
  Object.keys(options).forEach((key) => {
    const _key = `${key}Api`

    if (!https[_key]) {
      https[_key] = createInstance()
    }

    https[_key].defaults.baseURL = options[key] || ''
  })
}

/**
 * 获取请求实例
 * @param code
 * @returns
 */
const createRequest = (code: string) => {
  let _key = 'defaultApi'

  if (code) {
    _key = `${code}Api`
  }

  if (!https[_key]) {
    https[_key] = createInstance()

    if (code) {
      //首次创建时 尝试从环境变量中取API地址
      const defaultURL = process.env[`API_${code.toUpperCase()}_URL`]
      https[_key].defaults.baseURL = defaultURL || ''
    }
  }

  return https[_key]
}

export { axios, createRequest, setApiOptions }
